import React from "react";
import { Button, Col, Form, Input, Row } from "antd";
import { Link, Navigate, useLocation, useNavigate } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { signInAction } from "../store/authActions";
import logo from "../../../assets/images/logo.png";
import "./index.css";

const Login = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const location = useLocation();
  const authLoading = useSelector((state) => state.auth.loading);
  const authError = useSelector((state) => state.auth.error);
  const token = useSelector((state) => state.auth.token);
  const from = location.state?.from?.pathname || "/";

  const handleLogin = async (values) => {
    await dispatch(signInAction(values)).then((response) => {
      const { type } = response;

      if (
        type === "auth/signIn/fulfilled" &&
        response?.payload?.role?.slug === "super_admin"
      ) {
        navigate("/", { replace: true });
      }
    });
  };

  if (token) return <Navigate to={from}></Navigate>;
  else
    return (
      <>
        <div className="auth_parent_cont">
          <Row gutter={[10, 0]} className="row_inside">
            <Col span={24} className="col_box form_cont">
              <img src={logo} className="logo_image" alt="logo" />
              <p className="heading_signin">Sign in </p>
              <p className="error-msg">{authError}</p>

              <Form
                name="login"
                labelCol={{
                  span: 24,
                }}
                wrapperCol={{
                  span: 24,
                }}
                initialValues={{}}
                onFinish={handleLogin}
                autoComplete="off"
                style={{ marginTop: 10, width: "100%" }}
              >
                <Form.Item
                  label="Email"
                  name="email"
                  rules={[
                    {
                      required: true,
                      message: "Email is required",
                    },
                    {
                      type: "email",
                      message: "Invalid Email",
                    },
                  ]}
                >
                  <Input size="large" placeholder="Enter your email" />
                </Form.Item>
                <Form.Item
                  className="password_field"
                  label={
                    <div
                      style={{
                        width: " 100%",
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "space-between",
                      }}
                    >
                      <p>Password</p>
                    </div>
                  }
                  name="password"
                  rules={[
                    {
                      required: true,
                      message: "Password is required",
                    },
                  ]}
                >
                  <Input.Password
                    size="large"
                    placeholder="Enter your password"
                  />
                </Form.Item>

                <ul className="list-text"></ul>
                <Form.Item
                  wrapperCol={{
                    span: 24,
                  }}
                >
                  <Button
                    className="auth-btn"
                    type="primary"
                    loading={authLoading}
                    htmlType="submit"
                  >
                    Sign in
                  </Button>
                  <p className="already">
                    Don't have an account?{" "}
                    <Link to="/signup" className="blue_color">
                      Create Account
                    </Link>
                  </p>
                </Form.Item>
              </Form>
            </Col>
          </Row>
        </div>
      </>
    );
};

export default Login;
